import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";

class AddGoalForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      description: "",
      portfolio_id: null,
    };

    this.descriptionRef = React.createRef();
  }

  componentDidMount() {
    if (this.descriptionRef.current) {
      this.descriptionRef.current.focus();
    }
  }

  handleSave() {
    if (!this.state.description.trim()) {
      alert("Please enter a goal description");
      return;
    }

    try {
      const goal = {
        description: this.state.description.trim(),
        portfolio_id: this.state.portfolio_id,
      };

      this.props.onSave(goal);

      this.setState({
        description: "",
        portfolio_id: null,
      });
    } catch (error) {
      console.error("Error saving goal:", error);
      alert("There was an error saving your goal. Please try again.");
    }
  }

  render() {
    const { portfolios } = this.props;

    return (
      <div className="cs-add-goal-form mt-3">
        <h4 className="mt-0">Add Goal</h4>

        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label>
                <strong>Portfolio</strong>
              </Form.Label>
              <Form.Control
                as="select"
                value={this.state.portfolio_id || ""}
                onChange={(e) =>
                  this.setState({
                    portfolio_id: e.target.value === "" ? null : e.target.value,
                  })
                }
              >
                <option value="">All Portfolios</option>
                {portfolios.map((portfolio) => (
                  <option key={portfolio.id} value={portfolio.id}>
                    {portfolio.name || "Unnamed Portfolio"}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>

          <Col md={9}>
            <Form.Group>
              <Form.Label>
                <strong>Goal Description</strong>
              </Form.Label>
              <Form.Control
                type="text"
                ref={this.descriptionRef}
                placeholder="Make 1M over the next 5 years."
                value={this.state.description}
                onChange={(e) => this.setState({ description: e.target.value })}
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="text-right">
          <Button variant="very-very-good" className="mr-2" onClick={() => this.handleSave()}>
            Save Goal
          </Button>
          <Button variant="secondary" onClick={this.props.onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}

export default AddGoalForm;
